import { cn } from '@/lib/ui/utils';
import { Slot } from '@radix-ui/react-slot';

function Skeleton({
  className,
  asChild = false,
  active = true,
  ...props
}: React.ComponentProps<'div'> & { asChild?: boolean; active?: boolean }) {
  const Component = asChild ? Slot : 'div';
  return (
    <Component
      data-slot="skeleton"
      data-active={active}
      className={cn(
        active && 'bg-accent/50 animate-skeleton-breathe motion-reduce:animate-none rounded-panel',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
